import styles from './Footer.module.scss'
import { Col, Container, Row } from 'react-bootstrap'
import { withTranslation } from 'next-i18next'
import tenantCmsObject from '@/entities/tenantCms/interface'
import FooterMenu from '@/components/template/footer/FooterMenu'
import { buildMenuCols } from '@/components/template/footer/lib'
import FooterAddress from '@/components/template/footer/FooterAddress'
import Icon from '@/components/elements/Icon'
import ThemeImage from '@/components/elements/media/ThemeImage/ThemeImage'
import BrandLinks from '@/themes/rex/components/template/footer/BrandLinks'

interface FooterProps {
  cms: tenantCmsObject
}

const Footer = ({ cms }: FooterProps) => {
  const menuCols = buildMenuCols(cms.categories, 4)

  return (
    <>
      <footer className={styles.footer}>
        <Container>
          <Row>
            <Col xs={12} sm={{ span: 8, offset: 2 }} md={{ span: 12, offset: 0 }} className={'px-4 px-sm-2'}>
              <Row>
                {menuCols.map((col, index: number) => {
                  return (
                    <Col md={3} lg={2} className={'p-0 p-md-2'} key={index}>
                      {col.map((menu: any, index: number) => {
                        return <FooterMenu title={menu.title} items={menu.items} key={index} />
                      })}
                    </Col>
                  )
                })}
                <Col xs={12} className={`${styles.divider} mt-0 mt-md-1 d-lg-none`} />

                <Col md={{ span: 12 }} lg={{ span: 3, offset: 1, order: 'first' }}>
                  <FooterAddress contactBlockSettings={cms.config.contactBlockSettings} />
                  <p className="mt-4 mb-3">
                    {cms.config?.socialMediaSettings?.facebookUrl && (
                      <a
                        href={cms.config.socialMediaSettings.facebookUrl}
                        className={styles.socialLink}
                        target={'_blank'}
                        rel="noreferrer"
                        data-tr-click="footer:social_media_icon:click"
                        data-tr-social_media_platform="facebook"
                      >
                        <span className={'visually-hidden-focusable'}>Facebook</span>
                        <Icon name="facebook" className={styles.icon} />
                      </a>
                    )}
                    {cms.config?.socialMediaSettings?.instagramUrl && (
                      <a
                        href={cms.config.socialMediaSettings.instagramUrl}
                        className={styles.socialLink}
                        target={'_blank'}
                        rel="noreferrer"
                        data-tr-click="footer:social_media_icon:click"
                        data-tr-social_media_platform="instagram"
                      >
                        <span className={'visually-hidden-focusable'}>Instagram</span>
                        <Icon name="instagram" className={styles.icon} />
                      </a>
                    )}
                    {cms.config?.socialMediaSettings?.linkedinUrl && (
                      <a
                        href={cms.config.socialMediaSettings.linkedinUrl}
                        className={styles.socialLink}
                        target={'_blank'}
                        rel="noreferrer"
                        data-tr-click="footer:social_media_icon:click"
                        data-tr-social_media_platform="linkedin"
                      >
                        <span className={'visually-hidden-focusable'}>LinkedIn</span>
                        <Icon name="linkedin" className={styles.icon} />
                      </a>
                    )}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className={styles.divider} />
              </Row>
              <BrandLinks />
              <Row>
                <Col className={styles.divider} />
              </Row>
              <Row>
                <Col xs={'auto'} md={3} lg={{ span: 3, offset: 1 }} className={'mb-3'}>
                  <small>&copy; {new Date().getFullYear()} rex - reisen mit expertise</small>
                </Col>
                <Col className={`text-end ${styles.trustLogos}`}>
                  <a
                    target={'_blank'}
                    href="https://www.garantiefonds.ch/"
                    rel="noreferrer"
                    data-tr-click="footer:trust_icon:click"
                    data-tr-trust_icon_name="Reisegarantie"
                  >
                    <ThemeImage src={'images/logos/logo-reisegarantie-white.png'} height={50} alt="Reisegarantie Logo" />
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  )
}

export default withTranslation(['common', 'theme'])(Footer)
